import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import moment from 'moment';
import React from 'react';
import Select from './select';
import Typography from 'fuse-ui/components/Typography';
import { find } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    root: {
        minWidth: '145px'
    },
    typo: {
        marginTop: 2
    }
} );

class Datepicker extends React.Component{
    changeDates = ( event ) => {
        const { dateOptions, handleDateChange } = this.props;
        const option = event.target.value;
        const selected = find( dateOptions, { key: option } );
        const { start, end } = selected;
        handleDateChange( option, start, end );
    }

    render(){
        const { selectedOption, classes, automationId, dateOptions } = this.props;
        const selected = find( dateOptions, { key: selectedOption } );
        const renderedSelectedOption = `${selected.display} (${moment( selected.start ).format( 'YYYY/MM/DD' )} - ${moment( selected.end ).format( 'YYYY/MM/DD' )})`;

        return (
            <FormControl className={classes.root} data-automation-id={automationId}>
                <Select
                    value={selectedOption}
                    onChange={this.changeDates}
                    className="no-print"
                    renderValue={
                        () =>
                            ( <Typography
                                variant="body1"
                                classes={{ root: classes.typo }}>
                                {renderedSelectedOption}
                            </Typography> )
                    }
                >
                    {
                        dateOptions.map( ( option ) => {
                            return <MenuItem key={option.key} value={option.key}>{option.display}</MenuItem>;
                        } )
                    }
                </Select>
            </FormControl>
        );
    }
}

Datepicker.propTypes = {
    automationId: PropTypes.string,
    classes: PropTypes.object,
    dateOptions: PropTypes.array.isRequired,
    handleDateChange: PropTypes.func.isRequired,
    selectedOption: PropTypes.string.isRequired,
};

export default withStyles( styles )( Datepicker );
